/* eslint-disable @typescript-eslint/no-explicit-any */
import { defaultTextStyles } from './Text.styled'

const TEXT_PRESETS = [
  'huge',
  'h1',
  'h2',
  'h3',
  'h4',
  'h5',
  'h6',
  'small',
  'tiny',
  'link',
] as const
export type TextPresets = typeof TEXT_PRESETS[number]
export function isTextPreset(key: string): key is TextPresets {
  return TEXT_PRESETS.includes(key as TextPresets)
}

const huge = defaultTextStyles('4.375rem', '-1.32px')
const h1 = defaultTextStyles('4.938rem', '-2.37px', `line-height: 1.25;`)
const h2 = defaultTextStyles('3.375rem', '-1.35px', `line-height: 1.5;`)
const h3 = defaultTextStyles('2rem', '1.33px', `line-height: 1.5;`)
const h4 = defaultTextStyles('1.5rem', '1.33px')
const h5 = defaultTextStyles('1.125rem', '-0.36px')
const h6 = defaultTextStyles('1rem', '-0.32px')
const small = defaultTextStyles('0.875rem', '-0.28px')
const tiny = defaultTextStyles('0.75rem', '-0.24px')
const link = defaultTextStyles(
  '0.875rem',
  '-0.28px',
  `
  opacity: 1;
  transition: opacity 0.2s;
  cursor: pointer;
  text-decoration: underline;
  &:hover {
    opacity: 0.75;
  }
`
)

//@ts-ignore
export const textPresets: Record<TextPresets, any> = {
  huge,
  h1,
  h2,
  h3,
  h4,
  h5,
  h6,
  small,
  tiny,
  link,
}
